/**
 * StepNode — circular status icon for a single step in the service timeline.
 *
 * completed → filled forest circle with a checkmark
 * current   → white circle with forest border, clock icon, glow ring
 * upcoming  → muted circle with faded dot
 */
import { CheckCircle2, Clock, Circle } from 'lucide-react';
import type { StepStatus } from '../constants';
import { PALETTE_FOREST } from '../tokens';

interface StepNodeProps {
  status: StepStatus;
}

export function StepNode({ status }: StepNodeProps) {
  const base =
    'h-8 w-8 rounded-full border-2 flex items-center justify-center transition-all duration-300 shrink-0 z-10';

  if (status === 'completed') {
    return (
      <div
        className={base}
        style={{ backgroundColor: PALETTE_FOREST, borderColor: PALETTE_FOREST }}
      >
        <CheckCircle2 className="h-4 w-4 text-white" aria-hidden />
      </div>
    );
  }

  if (status === 'current') {
    return (
      <div
        className={base}
        style={{
          backgroundColor: '#fff',
          borderColor:     PALETTE_FOREST,
          boxShadow:       `0 0 0 3px ${PALETTE_FOREST}22`,
        }}
      >
        <Clock className="h-3.5 w-3.5" style={{ color: PALETTE_FOREST }} aria-hidden />
      </div>
    );
  }

  return (
    <div
      className={base}
      style={{
        backgroundColor: 'hsl(var(--muted))',
        borderColor:     'hsl(var(--border))',
      }}
    >
      <Circle className="h-3 w-3 text-muted-foreground opacity-30" aria-hidden />
    </div>
  );
}
